module.exports = __webpack_public_path__ + "img/931607811.e7a09394.jpg";